import styled from 'styled-components';
import Document from 'components/icons/note';
import { ORANGE_400 } from '../../../../../../constants';

export const StyledContainer = styled.div`
    display: flex;
    margin: 5px 0;
    flex-direction: row;
`;

export const StyledIconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${ORANGE_400};
    border-radius: 10px;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
`;

export const StyledIcon = styled(Document)`
    color: #fff;
    width: 16px !important;
    height: 16px !important;
`;

export const StyledContent = styled.div`
    flex: 1 1 auto;
    padding-left: 8px;
`;

export const StyledFileName = styled.p`
    font-size: 14px;
    font-weight: 400;
    word-wrap: break-word;
    word-break: break-word;
    margin: 0;
`;

export const StyledInfo = styled.p`
    font-size: 12px;
    font-weight: 400;
    margin: 0;
`;
